/**
 * Escapes a string value for safe interpolation inside an OData `$filter`
 * literal. OData escapes single quotes by doubling them.
 */
export function escapeODataValue(value: string): string {
  return value.replace(/'/g, "''");
}
